// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Martinique from '../_raw/flag/icon_flag_martinique.png';

export default () => <img src={Martinique} alt="Martinique" />;
